import { FieldType, MagazineNewspaperPublicationField, RowType } from '../../../../components/GenericSection';
import { START, END } from './../../../constants';
var MAGAZINE_PUBINFO_SECTION_FIELDS = [{
  field: MagazineNewspaperPublicationField.TITLE,
  labelText: 'Magazine title',
  type: FieldType.TEXT
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: MagazineNewspaperPublicationField.VOLUME,
    labelText: 'Volume',
    type: FieldType.TEXT,
    flex: '2'
  }, {
    field: MagazineNewspaperPublicationField.ISSUE,
    labelText: 'Issue',
    type: FieldType.TEXT,
    flex: '2'
  }]
}, {
  field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
  type: FieldType.PUBDATE,
  labelText: 'Date published',
  formikFieldNames: ['day', 'month', 'year']
}, {
  fields: [{
    field: MagazineNewspaperPublicationField.START_PAGE,
    labelText: START,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.END_PAGE,
    labelText: END,
    type: FieldType.TEXT
  }]
}];
export default MAGAZINE_PUBINFO_SECTION_FIELDS;